// src/stone/icons/Pig.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Pig = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10 12a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1M13 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M10 20a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1M16 20a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M9.62 7h6.88a7.5 7.5 0 1 1 0 15h-7a7.5 7.5 0 0 1-6.633-4H1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1.872a7.5 7.5 0 0 1 1.874-2.298L4.04 6.28a1 1 0 0 1 .631-1.224L5 6a87 87 0 0 1-.328-.945h.001l.003-.001.005-.002.015-.005a2 2 0 0 1 .17-.05 4.55 4.55 0 0 1 1.818-.095C7.704 5.06 8.838 5.626 9.62 7m-3.326-.132.085.011c.527.081 1.22.374 1.7 1.51A1 1 0 0 0 9 9h7.5a5.5 5.5 0 1 1 0 11h-7a5.5 5.5 0 0 1-5.077-3.385A1 1 0 0 0 3.5 16H2v-3h1.505a1 1 0 0 0 .922-.614 5.53 5.53 0 0 1 2.028-2.465 1 1 0 0 0 .405-1.112z" })
    ]
  }
);
var Pig_default = Pig;

export {
  Pig_default
};
